import './index.less';
import * as React from 'react';
import { MobXProviderContext, observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import useDelayedFlag from '@src/utils/hooks/use-delayed-flag';
import useMount from '@src/utils/hooks/use-mount';
import { scrollToPageBottom } from '@src/utils/scroll-initial-position';
import CommonLoading from '@src/components/common-loading';
import Page from '@src/components/page';
import MoPoster from '@src/ui-components/mo-poster';
import Qr from '@src/components/qr';
import EndedPosterStore from './store';

const styles = require('./index.less');

const EndedPosterContent = () => {
  const { activitySessionStore } = React.useContext(MobXProviderContext);
  const store = useStore(() => new EndedPosterStore({ activitySessionStore }));
  // 短于 300ms 的加载不渲染遮罩：缓存命中/快速响应不闪屏，慢请求照常出现
  const showLoading = useDelayedFlag(store.loadStatus === 'loading');
  // 2026-09-22 需求：海报页进入即居底，直接露出底部按钮区（前往组队 / 保存海报）
  useMount(() => {
    scrollToPageBottom();
  });

  return (
    <Page className={styles.root}>
      <MoPoster
        qrMode={store.qrMode}
        sectKey={store.sectKey}
        viewModel={store.posterViewModel}
        /* 数据未就绪（loading / 异常）时编辑入口与底部操作统一禁用（PSD 语义按钮的受控禁用态） */
        actionsDisabled={store.loadStatus !== 'ready'}
        /* QR 实例仅在数据就绪且 currentQrTarget 有效时挂载（data-ready-widget-initialization）：
           home/team 模式的目标 URL 可先于 get_poster 从运行地址派生，若只看 isCurrentQrTargetAvailable
           会在 loading 期挂出一个随后被真实邀请参数替换的占位实例，故必须叠加 loadStatus 门控；
           槽位几何由静态壳的二维码区承载，这里只提供受控实例节点 */
        qrCodeNode={
          store.loadStatus === 'ready' && store.isCurrentQrTargetAvailable ? (
            /* includeMargin：qrcode.react 默认顶格无静区，扫码器无法定位；开启后四周留 4 模块白色静区（视觉 74px 槽位内 QR 本体约 63px） */
            <Qr value={store.currentQrTarget} size={74} includeMargin wrapperClassName={styles.qrWrapper} />
          ) : null
        }
        onOpenTagEditor={store.openTagEditor}
        onOpenRoleEditor={store.openRoleEditor}
        onSavePoster={store.savePoster}
        /* 底部左按钮（2026-09-20 需求）：前往组队页（原复制入口移入分享海报弹窗底部） */
        onGoTeam={store.goTeamPage}
      />
      {/* findings 授权的页面层临时关闭按钮：PSD 无对应节点，视觉最小化并避开海报内容；
          来源感知关闭（Task 7）：来源由调用方经 URL query 显式携带并在 Store use() 校验存储，
          closePage 返回合法来源页，无来源或非法来源回组队主页 */}
      {/* <button className={styles.closeButton} type="button" aria-label="关闭海报页" data-name="临时关闭按钮" onClick={store.closePage} /> */}
      {showLoading ? (
        <div className={styles.loading} data-name="海报加载中">
          <CommonLoading />
        </div>
      ) : null}
    </Page>
  );
};

const ObservedEndedPosterContent = observer(EndedPosterContent);

const EndedPoster = () => <ObservedEndedPosterContent />;

export default EndedPoster;
